module.exports = __webpack_public_path__ + "static/assets/95d958d0d61a1deb992133785784a322.png";